import React from "react";
import logo_url_here from "../../../assets/img/SimpleRenovate.svg";
import tick_client from "../../../assets/img/tick_client.svg";
import qr_code from "../../../assets/img/client_qr_code.png";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import TabletMacOutlinedIcon from "@mui/icons-material/TabletMacOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import { Col, Row } from "react-bootstrap";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import buy_credit from "../../../assets/img/buy_credit.svg";
import ManagePayments from "../../../assets/img/Manage Payments.svg";
import BetterExperience from "../../../assets/img/Better Experience.svg";
import pauseIcon from "../../../assets/img/pause icon.svg";

const ClientDashboard = () => {
  return (
    <div className="pro-app-page pro-app-page--muted">
      <div className="client_dashboard">
        <div className="account-created-container">
          <header className="header">
            <img
              className="logo"
              src={logo_url_here}
              alt="SimpleRenovate Logo"
            />
          </header>
          <main className="content">
            <img className="logo" src={tick_client} alt="tick-client" />
            <h1 className="title">Account Created Successfully!</h1>
            <p className="welcome-text">Welcome to SimpleRenovate</p>
            <section className="download-app">
              <h2 className="download-title">Download Our Mobile App</h2>
              <p className="instructions">
                To post your renovation projects and connect with trusted professionals, please
                download our mobile app.
              </p>
              <div className="qr-code">
                <div className="qr_center">
                  <div className="qr-code-container">
                    <div className="qr-code-image">
                      <img src={qr_code} alt="Scan QR code to download" />
                    </div>
                  </div>
                </div>
                <p className="qr-text">Scan QR code to download</p>
                <p className="instructions">
                  Point your camera at the QR code to download the app
                </p>
              </div>
              <div className="download-links">
                <div className="btn_bg">
                  <FileDownloadOutlinedIcon />
                  <div className="text-start">
                    <a href="https://apps.apple.com/us/app/simplerenovate-get-quotes/id6739887309" target="_blank" rel="noreferrer noopener" className="button">
                      Download on
                    </a>
                    <br />
                    <span>App Store</span>
                  </div>
                </div>
                <div className="btn_bg btn_bg_1">
                  <img src={pauseIcon} alt="Pause Icon" />
                  <div className="text-start">
                    <a href="#" className="button">
                      Download on
                    </a>
                    <br />
                    <span>Google Play (Coming Soon)</span>
                  </div>
                </div>
              </div>
            </section>
            <section className="features">
              <h3 className="features-title">What you can do with the app:</h3>
              <ul className="feature-list">
                <li>
                  <TaskAltOutlinedIcon className="mt-1" />
                  <span>
                    Post renovation projects with photos and details.
                  </span>
                </li>
                <li>
                  <TaskAltOutlinedIcon className="mt-1" />
                  <span>Receive and compare multiple bids from professionals.</span>
                </li>
                <li>
                  <TaskAltOutlinedIcon className="mt-1" />
                  <span>Chat directly with professionals to discuss project details.</span>
                </li>
                <li>
                  <TaskAltOutlinedIcon className="mt-1" />
                  <span>Track project progress and milestones.</span>
                </li>
              </ul>
            </section>
            {/* <div className="footer">
              <p>
                Not ready to download the app?
                <br />
                <a href="/client/dashboard">Continue with web (Coming Soon)</a>
              </p>
            </div> */}
          </main>
        </div>
      </div>

      {/* <div className="client_bottom_card">
        <div className="custom_container">
          <div className="feature-cards-container">
            <Row>
              <Col sm={12} md={6} lg={4} className="mt-3">
                <div className="feature-card">
                  <img
                    src={buy_credit}
                    alt="Buy Credits icon"
                    className="feature-icon"
                  />
                  <h3 className="feature-title">Buy Credits</h3>
                  <p className="feature-description">
                    Use credits to post bids on jobs and get more responses from
                    homeowners.
                  </p>
                  <a
                    href="#"
                    className="feature-link"
                    style={{ color: "#9fa5b1" }}
                  >
                    Learn More (Coming Soon on Web)
                  </a>
                </div>
              </Col>
              <Col sm={12} md={6} lg={4} className="mt-3">
                <div className="feature-card">
                  <img
                    src={ManagePayments}
                    alt="Manage Payments icon"
                    className="feature-icon"
                  />
                  <h3 className="feature-title">Manage Payments</h3>
                  <p className="feature-description">
                    Manage payment methods, view billing history, and handle
                    subscriptions or invoices here.
                  </p>
                  <a
                    href="#"
                    className="feature-link"
                    style={{ color: "#9fa5b1" }}
                  >
                    Go to Billing (Coming Soon on Web)
                  </a>
                </div>
              </Col>

              <Col sm={12} md={6} lg={4} className="mt-3">
                <div className="feature-card">
                  <img
                    src={BetterExperience}
                    alt="Better Experience icon"
                    className="feature-icon"
                  />
                  <h3 className="feature-title">Better Experience</h3>
                  <p className="feature-description">
                    Download the SimpleRenovate App to post projects and manage
                    them seamlessly.
                  </p>
                  <a href="/download-app" className="feature-link">
                    Get the App <ArrowForwardOutlinedIcon />
                  </a>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default ClientDashboard;
